
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 32 32","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_800_7123)"}},[_c('path',{attrs:{"d":"M32 6.076a13.107 13.107 0 01-3.77 1.033 6.576 6.576 0 002.886-3.632 13.151 13.151 0 01-4.17 1.594 6.554 6.554 0 00-4.791-2.074c-4.239 0-7.354 3.955-6.396 8.06C10.304 10.784 5.467 8.171 2.228 4.2a6.574 6.574 0 002.03 8.765 6.538 6.538 0 01-2.971-.821c-.072 3.041 2.108 5.886 5.265 6.52-.924.25-1.936.309-2.965.112a6.57 6.57 0 006.133 4.558A13.2 13.2 0 010 26.053a18.585 18.585 0 0010.064 2.95c12.19 0 19.076-10.295 18.66-19.528A13.366 13.366 0 0032 6.076z","fill":"#fff"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_800_7123"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h32v32H0z"}})])])])
          )
        }
      }
    